export const getMinutesAndSeconds = (totalMilliseconds?: number): string => {
  if (typeof totalMilliseconds === 'undefined') {
    return ':';
  }
  const totalSeconds = Math.round(totalMilliseconds / 1000);
  const totalFullMinutes = Math.floor(totalSeconds / 60);
  const totalSecondsRemainder = totalSeconds % 60;
  const secondsWithZeroPad = String(totalSecondsRemainder).padStart(2, '0');
  return `${totalFullMinutes}:${secondsWithZeroPad}`;
};
